"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "crema": {
    "1de09127": [{
      "hkey": "472d3bf1",
      "slug": "ombriano-sabbioni",
      "name": "Ombriano-Sabbioni",
      "primary": true,
      "skipSearch": false
    }],
    "62c6bc66": [{
      "hkey": "cbc2d4a8",
      "slug": "crema",
      "name": "Crema",
      "primary": true,
      "skipSearch": false
    }],
    "65f58894": [{
      "hkey": "472d3bf1",
      "slug": "ombriano-sabbioni",
      "name": "Ombriano-Sabbioni",
      "primary": false,
      "skipSearch": false
    }],
    "ombriano": [{
      "hkey": "472d3bf1",
      "slug": "ombriano-sabbioni",
      "name": "Ombriano-Sabbioni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "sabbioni": [{
      "hkey": "472d3bf1",
      "slug": "ombriano-sabbioni",
      "name": "Ombriano-Sabbioni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "crema"
    }],
    "san-michele": [{
      "hkey": "cbc2d4a8",
      "slug": "crema",
      "name": "Crema",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;